<template>
  <main class="container">
      <div class="info">
          <h1>{{title}}</h1>
          <h2>{{page}}</h2>
          <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Cumque odio dolor ratione alias commodi illo libero quaerat molestiae facilis autem voluptate ullam deserunt nesciunt, possimus consequuntur tempore illum quos placeat!</p>
      </div>
  </main>
</template>

<script>

export default {
    name:"Info",
    props: ['title','page'],
}

</script>

<style scoped>
.info{
    min-height: 500px;

}


</style>